import React from 'react';
import { Button, Form, Modal, Table } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { RiMore2Line } from '@remixicon/react';
import styled from 'styled-components';
import {
  CompanyMobileActionButton,
  CompanyMobileBackButton,
  CompanyMobileFilterActions,
  CompanyMobileFilterApplyButton,
  CompanyMobileFilterButton,
  CompanyMobileFilterDrawer,
  CompanyMobileFilterField,
  CompanyMobileFilterFields,
  CompanyMobileFilterForm,
  CompanyMobileFilterRow,
  CompanyMobileFilterSelect,
  CompanyMobileField,
  CompanyMobileHeader,
  CompanyMobileHeaderActions,
  CompanyMobileHeaderLeft,
  CompanyMobileIconButton,
  CompanyMobilePage,
  CompanyMobilePageButton,
  CompanyMobilePagination,
  CompanyMobilePaginationActions,
  CompanyMobilePaginationInfo,
  CompanyMobileSearch,
  CompanyMobileSecondaryButton,
  CompanyMobileSection,
  CompanyMobileSectionHeader,
  CompanyMobileSwitchField,
} from '../company/mobile';

type MasterReportMobileHeaderProps = {
  title: string;
  onBack?: () => void;
  action?: React.ReactNode;
};

export const MasterReportMobilePage = styled(CompanyMobilePage)`
  gap: 12px;
`;

export const MasterReportMobileHeaderActions = CompanyMobileHeaderActions;
export const MasterReportMobileActionButton = CompanyMobileActionButton;
export const MasterReportMobileSecondaryButton = CompanyMobileSecondaryButton;
export const MasterReportMobileIconButton = CompanyMobileIconButton;
export const MasterReportMobileFilterRow = CompanyMobileFilterRow;
export const MasterReportMobileSearch = CompanyMobileSearch;
export const MasterReportMobileFilterButton = CompanyMobileFilterButton;
export const MasterReportMobileFilterDrawer = CompanyMobileFilterDrawer;
export const MasterReportMobileFilterForm = CompanyMobileFilterForm;
export const MasterReportMobileFilterFields = CompanyMobileFilterFields;
export const MasterReportMobileFilterField = CompanyMobileFilterField;
export const MasterReportMobileFilterSelect = CompanyMobileFilterSelect;
export const MasterReportMobileFilterActions = CompanyMobileFilterActions;
export const MasterReportMobileFilterApplyButton =
  CompanyMobileFilterApplyButton;
export const MasterReportMobilePagination = CompanyMobilePagination;
export const MasterReportMobilePaginationInfo = CompanyMobilePaginationInfo;
export const MasterReportMobilePaginationActions =
  CompanyMobilePaginationActions;
export const MasterReportMobilePageButton = CompanyMobilePageButton;
export const MasterReportMobileForm = styled.div`
  width: 100%;
  padding: 12px 0 24px;
`;

export const MasterReportMobileSection = styled(CompanyMobileSection)`
  margin-bottom: 12px;
  padding-bottom: ${(props) => (props.$bordered ? '12px' : '0')};
`;

export const MasterReportMobileSectionHeader = styled(
  CompanyMobileSectionHeader,
)`
  margin-bottom: 8px;

  h2 {
    font-size: 14px;
    line-height: 1.2;
  }

  p {
    margin-top: 4px;
    color: #768499;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const MasterReportMobileField = styled(CompanyMobileField)`
  && {
    margin-bottom: 8px;
  }

  .ant-picker {
    width: 100%;
    height: 44px;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
  }

  .ant-picker-input > input {
    font-size: 12px;
    line-height: 1.2;
  }

  .ant-picker-input > input::placeholder {
    color: #bfbfbf;
    font-size: 12px;
  }
`;

export const MasterReportMobileSwitchField = CompanyMobileSwitchField;

export const MasterReportMobileInfoPanel = styled.div`
  width: 100%;
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #9dc8fa;
  border-radius: 6px;
  background: #e8f4fe;
  color: #000000;
  font-size: 12px;
  line-height: 1.2;
`;

export const MasterReportMobileInfoTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.2;
`;

export const MasterReportMobileParamGroup = styled.div`
  margin: 0 0 10px 28px;

  strong {
    display: block;
    margin-bottom: 8px;
    color: #000000;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
  }
`;

export const MasterReportMobileParamList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .ant-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 28px;
    margin: 0;
    padding: 5px 10px;
    border: 0;
    border-radius: 4px;
    background: #418be1;
    color: #ffffff;
    font-size: 12px;
    line-height: 1.2;
    cursor: pointer;
  }
`;

export const MasterReportMobileParamExamples = styled.div`
  margin-left: 28px;
  color: #000000;
  font-size: 12px;
  line-height: 1.2;

  div + div {
    margin-top: 8px;
  }

  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const MasterReportMobileWarningPanel = styled.div`
  width: 100%;
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #fbe59a;
  border-radius: 6px;
  background: #fffbe7;
  color: #000000;
  font-size: 12px;
  line-height: 1.2;
`;

export const MasterReportMobileEditorWrap = styled.div`
  width: 100%;
  min-height: 520px;
  overflow: hidden;
  border: 1px solid #e8ecf3;
  border-radius: 6px;
  background: #ffffff;

  iframe {
    max-width: 100%;
  }
`;

export const MasterReportMobileTargetTable = styled(Table)`
  width: 100%;

  .ant-table-container {
    overflow: hidden;
    border-radius: 12px 12px 0 0;
  }

  .ant-table-content {
    overflow-x: auto !important;
  }

  .ant-table-content table {
    min-width: 528px;
  }

  && .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  && .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  && .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    border-bottom: 1px solid #e8ecf3;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  && .ant-table-row-selected > td {
    background: rgba(9, 88, 217, 0.1) !important;
  }
`;

export const MasterReportMobileRadioRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  width: 100%;

  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .ant-radio-wrapper {
    margin-right: 0;
    color: #000000;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const MasterReportMobileArchivedAlert = styled.div`
  margin-bottom: 12px;
`;

export const MasterReportMobileHeader = ({
  title,
  onBack,
  action,
}: MasterReportMobileHeaderProps) => (
  <CompanyMobileHeader>
    <CompanyMobileHeaderLeft>
      {onBack ? (
        <CompanyMobileBackButton
          type='button'
          onClick={onBack}
          aria-label='Back'
        >
          <LeftOutlined />
        </CompanyMobileBackButton>
      ) : null}
      <MasterReportMobileHeaderCopy>
        <h1>{title}</h1>
      </MasterReportMobileHeaderCopy>
    </CompanyMobileHeaderLeft>
    {action}
  </CompanyMobileHeader>
);

export const MasterReportMobileHeaderCopy = styled.div`
  min-width: 0;

  h1 {
    max-width: 182px;
    margin: 0;
    overflow: hidden;
    color: #1e1e1e;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const MasterReportMobileTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: calc(100% + 40px);
  margin: 0 -20px;
  padding: 0 20px;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid #e8ecf3;
  background: #ffffff;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MasterReportMobileTabButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  padding: 2px 0 0;
  border: 0;
  border-bottom: 2px solid
    ${(props) => (props.$active ? '#264284' : 'transparent')};
  background: transparent;
  color: ${(props) => (props.$active ? '#264284' : '#9facbf')};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
`;

export const MasterReportMobileTableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: #ffffff;
`;

export const MasterReportMobileTable = styled.table<{ $minWidth?: number }>`
  width: ${(props) => props.$minWidth ?? 760}px;
  min-width: ${(props) => props.$minWidth ?? 760}px;
  border-collapse: collapse;
  background: #ffffff;

  thead tr {
    height: 46px;
    border-bottom: 1px solid #d9d9d9;
    background: #fafafa;
  }

  th {
    padding: 12px;
    border-right: 1px solid #d9d9d9;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    text-align: left;
    white-space: nowrap;
  }

  th:last-child {
    border-right: 0;
  }

  tbody tr {
    min-height: 48px;
    border-bottom: 1px solid #e8ecf3;
  }

  td {
    padding: 16px 12px;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    vertical-align: middle;
    white-space: nowrap;
  }
`;

export const MasterReportMobileLinkText = styled.button`
  display: inline-flex;
  max-width: 180px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0e3b7a;
  font-size: 12px;
  line-height: 1.2;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
`;

export const MasterReportMobileStatus = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid ${(props) => (props.$active ? '#73c241' : '#eeb141')};
  border-radius: 5px;
  background: ${(props) => (props.$active ? '#f8ffef' : '#fffbe7')};
  color: ${(props) => (props.$active ? '#73c241' : '#eeb141')};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-transform: capitalize;
`;

export const MasterReportMobileMoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1e1e1e;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MasterReportMobileMoreIcon = () => <RiMore2Line />;

export const MasterReportMobileStackCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 180px;
  white-space: normal;

  span {
    color: #595959;
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0.16px;
  }

  strong {
    color: #1e1e1e;
    font-size: 10px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: 0.2px;
  }
`;

export const MasterReportMobileEmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 96px;
  padding: 16px;
  border: 1px solid #e8ecf3;
  border-radius: 6px;
  background: #ffffff;
  color: #768499;
  font-size: 14px;
  text-align: center;
`;

export const MasterReportMobileCustomEmailModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    overflow: hidden;
    border-radius: 8px;
  }

  .ant-modal-header {
    margin: 0;
    padding: 16px 10px 0;
    border-bottom: 0;
  }

  .ant-modal-title {
    text-align: center;
  }

  .ant-modal-body {
    padding: 0 10px 0;
  }
`;

export const MasterReportMobileCustomEmailTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 52px;

  h2 {
    margin: 0;
    color: #1e1e1e;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
  }

  p {
    max-width: 300px;
    margin: 0;
    color: #768499;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }
`;

export const MasterReportMobileCustomEmailBody = styled.div`
  .ant-form-item {
    margin-bottom: 8px;
  }

  .ant-form-item-label {
    padding-bottom: 3px;
  }

  .ant-form-item-label > label {
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .ant-form-item-required::before {
    margin-inline-end: 5px !important;
    color: #ff3a3a !important;
    font-family: Roboto, sans-serif !important;
    font-size: 12px !important;
    line-height: 18px !important;
  }

  .ant-input,
  .ant-select-selector,
  .ant-picker {
    min-height: 44px;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    color: #1e1e1e;
    font-size: 14px;
  }

  .ant-select-selector {
    display: flex;
    align-items: center;
    height: 44px !important;
    padding: 0 10px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
    height: 42px;
    line-height: 1.2 !important;
  }

  .ant-input::placeholder,
  .ant-select-selection-placeholder,
  .ant-picker-input > input::placeholder {
    color: #bfbfbf;
  }

  .ant-form-item-extra,
  .ant-form-item-explain {
    color: #bfbfbf;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const MasterReportMobileCustomEmailActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  padding: 16px 0;
  border-top: 1px solid #e8ecf3;
`;

export const MasterReportMobileCustomEmailCancelButton = styled(Button)`
  && {
    width: 120px;
    height: 44px;
    border-color: #e8ecf3;
    border-radius: 6px;
    background: #ffffff;
    color: #1e1e1e;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`;

export const MasterReportMobileCustomEmailSubmitButton = styled(Button)`
  && {
    width: 119px;
    height: 44px;
    border: 0;
    border-radius: 6px;
    background: #264284;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  &&:hover,
  &&:focus {
    background: #264284;
    color: #ffffff;
  }
`;
